import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import style from './index.module.scss';

export interface BaseDialogProps {
    className?: string;
    show: boolean;
    onClose?: () => void;
    children?: React.ReactNode;
}

const BaseDialog: React.FC<BaseDialogProps> = ({ className, show = false, onClose, children }) => {
    useEffect(() => {
        if (typeof window !== 'undefined') {
            document.body.style.overflow = show ? 'hidden' : 'auto';
        }
    }, [show]);
    return show
        ? createPortal(
              <div className={`${style.comp} ${className}`}>
                  <div className="dialog-container">
                      <div className="dialog-body">
                          <img
                              className="dialog-close"
                              onClick={onClose}
                              draggable="false"
                              src="https://websiteoss.ecoflow.com/upload/image/1740649201644/dialog-icon.png"
                              alt=""
                          />
                          {children}
                      </div>
                  </div>
              </div>,
              document.body,
          )
        : null;
};
export default BaseDialog;
